import { render, staticRenderFns } from "./onebox-register_mohpromt2.vue?vue&type=template&id=2aa0f9b3&"
import script from "./onebox-register_mohpromt2.vue?vue&type=script&lang=js&"
export * from "./onebox-register_mohpromt2.vue?vue&type=script&lang=js&"
import style0 from "./onebox-register_mohpromt2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports